import React from 'react';
import { Paper, Typography, Grid } from '@mui/material';

const ReservationCustomerDetails = ({ order }) => (
  <>
    <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
      Dane osobowe
    </Typography>
    <Paper variant="outlined" sx={{ p: 2, mb: 3, borderRadius: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">Imię i nazwisko</Typography>
          <Typography variant="body1" fontWeight={500}>
            {[order?.firstName, order?.lastName].filter(Boolean).join(' ') || '—'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">E-mail</Typography>
          <Typography variant="body1" fontWeight={500}>{order?.email || '—'}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">Telefon</Typography>
          <Typography variant="body1" fontWeight={500}>
            {[order?.countryPrefix, order?.phoneNumber].filter(Boolean).join(' ') || '—'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">Adres</Typography>
          <Typography variant="body1" fontWeight={500}>{order?.address || '—'}</Typography>
        </Grid>
      </Grid>
    </Paper>
  </>
);

export default ReservationCustomerDetails;
